import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { ADD_ROWS_PER_PAGE } from "../redux/constants";
import { addRowsPerPage } from "../redux/actions/auth";

function RowsPerPageSelector() {
  const options = [
    {
      label: 10,
      value: 10,
    },
    {
      label: 25,
      value: 25,
    },
    {
      label: 50,
      value: 50,
    },
    {
      label: 100,
      value: 100,
    },
  ];

  const dispatch = useDispatch();
  const { row_count } = useSelector((state) => state.auth);

  const [rowsPerPageChanged, setRowsPerPageChanged] = useState(0);
  const [rowsVal, setRowsVal] = useState(row_count ? row_count : 50)

  useEffect(() => {
    if (rowsPerPageChanged) {
      const request = {
        payload: row_count,
      };

      dispatch(addRowsPerPage(request));
    }
  }, [rowsPerPageChanged]);

  useEffect(() => {
   if(!row_count) {
    dispatch({ type: ADD_ROWS_PER_PAGE, payload: 50 });
   }
  }, [])
  

  return (
    <div className="flex items-center space-x-2">
      <Select
        className="basic-single text-sm unresetText"
        styles={{
          control: (provided) => ({
            ...provided,
            backgroundColor: "white",
            borderColor: "lightgray",
            width: "100px",
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          placeholder: (provided, state) => ({
            ...provided,
            color: "#9297A2",
            fontSize: "14px",
          }),
        }}
        classNames={{
          control: (style) => {
            return `!border !shadow-sm ${
              style.isFocused
                ? "!border-[--bg-color-300]/50"
                : "!border-slate-200 hover:!border-gray-300"
            }`;
          },
          container: (style) => {
            return "!h-[37.5px] !font-inter !text-sm";
          },
          menuList: (style) => {
            return `!max-h-[200px]`;
          },
        }}
        onChange={(event) => {
          dispatch({ type: ADD_ROWS_PER_PAGE, payload: event.value });
          setRowsPerPageChanged(rowsPerPageChanged + 1);
        }}
        value={options.find((item) => item.value === rowsVal)}
        options={options}
        placeholder=""
        menuPlacement="auto"
      />
      <p className="text-sm text-slate-500 font-medium">entries per page</p>
    </div>
  );
}

export default RowsPerPageSelector;
